import { array, object, string } from "yup";

export const smsFormSchema = object({
  type: string().optional(),
  recipients: array(
    object({
      name: string(),
      firstname: string(),
      phone: string(),
    })
  )
    .min(1, "Un destinataire est obligatoire.")
    .required(),
  content: object({
    text: string().required("Le contenu du sms ne peut être vide."),
    html: string(),
  }).required("Le contenu du sms ne peut être vide."),
});
